export default __webpack_public_path__ + "static/media/Productos.61b28ab6.png";